import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import { FlexCol, FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { NoItemsWrapper } from '../../Zemplin/General/NoItemsWrapper';
import { ZemplinLoaderWrapper } from '../../..';
import { ArticleCard } from './ArticleCard';
import { ArticleListItem } from './ArticleListItem';
import { prop } from '../../../utilities';
import { SearchArticleCard } from './SearchArticleCard';
import { Link } from 'react-router';

interface Props {
  articles: any;
  isFetching: boolean;
  numOfArticles: number;
  moreArticlesUrl: string;
}

function SearchArticlesList({
  articles,
  isFetching,
  moreArticlesUrl,
  numOfArticles,
}: Props) {
  if (!isFetching && (!articles || articles.length === 0)) {
    return null;
  }

  const articlesComponent =
    articles &&
    articles.map((a: any) => {
      // const categoryName = prop(sitemapsById[a.sitemapIds[0]], 'name');
      return (
        <SearchArticleCard
          categoryName={prop(a, 'author.name')}
          key={a.id}
          article={a}
        />
      );
    });

  return (
    <>
      {!isFetching && numOfArticles > 0 && (
        <NumWrapper>
          <NumberOfArticles>
            {numOfArticles === 1
              ? __('Našiel sa ')
              : numOfArticles < 5
              ? __('Našli sa')
              : `${__('Našlo sa ')}`}{' '}
            <b>{numOfArticles}</b>{' '}
            {numOfArticles === 1
              ? __('článok')
              : numOfArticles < 5
              ? __('články')
              : __('článkov')}
          </NumberOfArticles>
          {numOfArticles > 4 && (
            <MoreLink to={moreArticlesUrl}>{__('Ďalšie články')}</MoreLink>
          )}
        </NumWrapper>
      )}
      <ArticlesWrapper>
        {isFetching ? (
          <ZemplinLoaderWrapper height={200} />
        ) : articlesComponent && articlesComponent.length > 0 ? (
          <>{articlesComponent}</>
        ) : (
          <NoItemsWrapper height={200} text={__('Nenašli sa žiadne články')} />
        )}
      </ArticlesWrapper>
    </>
  );
}

const animateIn = keyframes`
   0% {
    opacity: 0;
    transform: scale(0.6) translateY(-8px);
  }
  
  100% {
    opacity: 1;
  }
`;

const ContentWrapper = styled(FlexCol)``;

const ArticlesWrapper = styled(FlexRow)`
  flex-flow: row wrap;
  margin-bottom: ${rem(24)};
  animation: ${animateIn} 0.2s ease;

  ${({ theme }) => theme.mediab.l925`
      justify-content: center;
  `};

  ${({ theme }) => theme.mediab.m810`
      margin-bottom: ${rem(32)};
  `};
`;

const MoreLink = styled(Link)`
  color: ${({ theme }) => theme.colors.textPrimary};

  &:hover {
    opacity: 0.8;
  }
`;

const NumberOfArticles = styled.span`
  font-size: ${rem(20)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.font.primary};
`;

const NumWrapper = styled(FlexRow)`
  margin-bottom: ${rem(16)};
  justify-content: space-between;
`;

export { SearchArticlesList };
